import { SearchProduto } from '../types';
import { warningProps } from '../types/context';

const warningDefault: warningProps = {
  type: '',
  message: '',
  has: false,
};

/**
 * Mantém exatamente a mesma regra do useEffect:
 * - Similar -> exibe alerta de similares
 * - Composição (tipo_movimentacao = 2 e tipo_preco_composicao = 0) -> exibe alerta e bloqueia edição de venda
 * - Se ambos acontecerem, Composição tem precedência.
 */
export const getWarningLabelFromProduct = (
  product: SearchProduto | null,
): warningProps => {
  if (!product) return warningDefault;

  const isSimilar = !!product.cod_similar && product.cod_similar > 0;
  const isComposicao =
    product.tipo_movimentacao === 2 && product.tipo_preco_composicao === 0;

  if (isComposicao) {
    return {
      type: 'composicao',
      has: true,
      message:
        'Produto é uma composição que segue a soma dos seus itens. Preço não pode ser alterado',
    };
  }

  if (isSimilar) {
    return {
      type: 'similar',
      has: true,
      message:
        'O produto está vinculado a Similares. Todos os similares vinculados também terão seu custo e preço alterados!',
    };
  }

  return warningDefault;
};
